import React from 'react';
import { motion } from 'framer-motion';

import php from '../assets/images/php-logo.png';
import flutter from '../assets/images/flutter-logo.png';
import react from '../assets/images/react-logo.png';
import node from '../assets/images/nodejs-logo.png';
import Figma from '../assets/images/figma-logo.png';
import Express from '../assets/images/express-js-logo.png';
import Laravel from '../assets/images/laravel-logo.png';
import Langgraph from '../assets/images/tech_stacks/langgraph_logo.png'
import langchain from '../assets/images/tech_stacks/langchain_logo.png'
import pytorch from '../assets/images/tech_stacks/pytorch_logo.png'
import pyhton from '../assets/images/tech_stacks/python_logo.png'
import tensorflow from '../assets/images/tech_stacks/Tensorflow_logo.png'
import N8n from '../assets/images/tech_stacks/n8n-logo-hd.webp'




const StackSection = () => {
  const technologies = [
    { src: php, label: "PHP" },
    { src: flutter, label: "Flutter" },
    { src: react, label: "React Js" },
    { src: node, label: "Node JS" },
    { src: Express, label: "Express JS" },
    { src: Laravel, label: "Laravel" },
    { src: Figma, label: "Figma" },
    { src: pyhton, label: "Python" },
    { src: Langgraph, label: "LangGraph" },
    { src: pytorch, label: "Pytorch" },
    { src: langchain, label: "LangChain" },
    { src: tensorflow, label: "TensorFlow" },
    { src: N8n, label: "N8n" },
  
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 50 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 12,
      },
    },
  };

  const labelHover = {
    opacity: 1,
    y: -10,
    transition: { type: "spring", stiffness: 300, damping: 20 },
  };

  // Text animations
  const textVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (customDelay = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: customDelay,
        type: "spring",
        stiffness: 100,
        damping: 20,
      },
    }),
  };

  return (
    <div className="flex flex-col items-center justify-center p-5 md:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-10">
      {/* Animate Heading */}
      <motion.h1
        className="font-extrabold text-2xl md:text-4xl text-gray-700"
        variants={textVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        custom={0}
      >
        Our Wide-ranging Technology Stack
      </motion.h1>

      {/* Animate Paragraph */}
      <motion.p
        className="font-semibold sm:text-xl text-lg mt-2 text-gray-700 max-w-4xl"
        variants={textVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        custom={0.3}
      >
        We deploy the newest development Technologies & Frameworks using a systematically-defined agile approach to build your scalable custom
        business applications in a timely manner. Our development team entails in-depth technology expertise and is perfectly competent to handle
        your simple to complex project requirements with absolute effortlessness.
      </motion.p>

      <motion.div
        className="px-5 max-w-7xl grid lg:grid-cols-5 md:grid-cols-4 grid-cols-2 gap-4"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {technologies.map((item, index) => (
          <motion.div
            key={index}
            className="flex flex-col items-center p-4 mx-2 cursor-pointer rounded-lg bg-white shadow-md"
            variants={cardVariants}
            whileHover={{
              scale: 1.1,
              rotate: 10,
              transition: { type: "spring", stiffness: 300, damping: 20 },
            }}
          >
            <img className="w-1/2 mb-2" src={item.src} alt={item.label} />
            <motion.h1
              className="text-lg font-semibold text-gray-500"
              initial={{ opacity: 0.7, y: 0 }}
              whileHover={labelHover}
            >
              {item.label}
            </motion.h1>
          </motion.div>
        ))}
        {/* Empty divs to balance the last row */}
        {Array.from({ length: 5 - (technologies.length % 5) }).map(
          (_, index) =>
            technologies.length % 5 !== 0 && (
              <div key={`empty-${index}`} className="p-2 mx-2 invisible"></div>
            )
        )}
      </motion.div>
    </div>
  );
};
export default StackSection;
